exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")();
// imports
exports.i(require("-!../node_modules/css-loader/index.js?{\"sourceMap\":false,\"importLoaders\":1}!../node_modules/postcss-loader/index.js!@angular/material/core/theming/prebuilt/deeppurple-amber.css"), "");
exports.push([module.id, "@import url(https://fonts.googleapis.com/icon?family=Material+Icons);", ""]);

// module
exports.push([module.id, "/* You can add global styles to this file, and also import other style files */\r\n\r\nbody {\r\n    background-color: #f6f6f6;\r\n}\r\n\r\nbody, html {\r\n    overflow-x: hidden;\r\n}\r\n\r\n@font-face {\r\n    font-family: 'MyriadPro';\r\n    src: url(" + require("./assets/fonts/MyriadPro-Regular.otf") + ");\r\n\r\n    font-weight: bold;\r\n}\r\n\r\n@font-face {\r\n    font-family: 'Corbel';\r\n    src: url(" + require("./assets/fonts/Corbel.ttf") + "); \r\n\r\n    font-weight: bold;\r\n}\r\n\r\ndiv.spinner {\r\n    text-align: center;\r\n    margin-top: 40px;\r\n}\r\n\r\n/*Angular2ImageGallery styles*/\r\n.thumbnail {\r\n    padding: 0;\r\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"sourceMap":false,"importLoaders":1}!./~/postcss-loader!./src/styles.css
// module id = 737
// module chunks = 2